/**
 * Lista de referencia para valores de las postulaciones
 */

export const listPostulacionModel = [
    {code: 'REMITIDA', value: 'Remitida'},
    {code: 'DESCARTADA', value: 'Descartada'},
    {code: 'CONTRATADA', value: 'Contratada'},
    {code: 'PRESENTADA', value: 'Presentada'},
    {code: 'NOREMITIDA', value: 'No remitida'} 
];